// extracted by mini-css-extract-plugin
export var img = "ratio-image-module--img--9LBvq";
export var imgBox = "ratio-image-module--img-box--qvR9u";
export var ratioContainer = "ratio-image-module--ratio-container--JeV3b";